(() => {
  const ROOT_SELECTOR = '[data-mns-promo-pricing]';
  const GRID_SELECTOR = '[data-mns-promo-grid]';

  /*
    Includes both:
    - Valid rendered custom grids
    - Invalid/incomplete custom-grid markers

    This is what determines whether BOLD should be overridden.
  */
  const CUSTOM_VARIANT_SELECTOR =
    '[data-has-custom-grid="true"][data-variant-id]';

  const ACTIVE_CLASS = 'mns-promo-pricing-active';


  function getProductInfo(root) {
    return (
      root.closest('[id^="ProductInfo-"]') ||
      root.closest('.product__info-container') ||
      root.closest('.shopify-section') ||
      document
    );
  }


  function getVariantId(root) {
    const productInfo = getProductInfo(root);

    const variantFields = productInfo.querySelectorAll(
      'form[action*="/cart/add"] [name="id"], ' +
      '[data-product-form] [name="id"]'
    );

    for (const field of variantFields) {
      if (field && field.value) {
        return String(field.value);
      }
    }


    const urlVariant = new URL(
      window.location.href
    ).searchParams.get('variant');

    if (urlVariant) {
      return String(urlVariant);
    }


    return String(
      root.dataset.initialVariantId || ''
    );
  }


  function getBoldElements(root) {
    const productInfo = getProductInfo(root);

    /*
      Find manually inserted BOLD grid.
    */

    const boldGrid = productInfo.querySelector('.bold_qb_grid');


    /*
      BOLD rendered table lives inside the same form
      as .bold_qb_grid, inside .money-template.
    */

    const boldForm = boldGrid
      ? boldGrid.closest('form[action*="/cart/add"]')
      : null;


    if (boldForm) {
      return boldForm.querySelectorAll(
        '.bold_qb_grid, ' +
        '.shappify_qb_grid, ' +
        '.money-template[data-product-id]'
      );
    }


    /*
      Fallback.
    */

    return productInfo.querySelectorAll(
      '.bold_qb_grid, ' +
      '.shappify_qb_grid, ' +
      '.money-template[data-product-id]'
    );
  }


  function setBoldVisibility(root, hideBold) {
    const productInfo = getProductInfo(root);
    const boldElements = getBoldElements(root);


    /*
      Product-level class used as an additional
      CSS safeguard.
    */

    productInfo.classList.toggle(
      ACTIVE_CLASS,
      hideBold
    );


    boldElements.forEach((element) => {

      if (hideBold) {

        element.style.setProperty(
          'display',
          'none',
          'important'
        );

      } else {

        element.style.removeProperty('display');

      }

    });
  }


  function syncDocumentActiveClass() {

    /*
      Keep the <html> class synchronized too.

      This preserves compatibility with any CSS using:

      html.mns-promo-pricing-active
      .mns-promo-pricing-active
    */

    const hasActiveCustomPricing = Array
      .from(document.querySelectorAll(ROOT_SELECTOR))
      .some((root) => {
        return root.dataset.promoActive === 'true';
      });


    document.documentElement.classList.toggle(
      ACTIVE_CLASS,
      hasActiveCustomPricing
    );
  }


  function updateGrid(root) {
    const variantId = getVariantId(root);

    const grids = root.querySelectorAll(
      GRID_SELECTOR
    );

    const customVariants = root.querySelectorAll(
      CUSTOM_VARIANT_SELECTOR
    );


    let matchingGridFound = false;
    let customPricingFound = false;


    /*
      --------------------------------------------------------
      CHECK WHETHER SELECTED VARIANT HAS ANY CUSTOM GRID DATA
      --------------------------------------------------------

      This includes:

      custom.grid_qty
      custom.grid_price
      custom.grid_promo

      If Liquid marked the variant as having custom grid data,
      BOLD must be overridden.
    */

    customVariants.forEach((item) => {

      const isCurrentVariant =
        String(item.dataset.variantId) === String(variantId);

      if (isCurrentVariant) {
        customPricingFound = true;
      }

    });


    /*
      --------------------------------------------------------
      SHOW VALID CUSTOM GRID
      --------------------------------------------------------

      Only actual valid grids receive [data-mns-promo-grid].

      Incomplete/mismatched custom data will still override
      BOLD, but no malformed custom table will be displayed.
    */

    grids.forEach((grid) => {

      const isCurrentVariant =
        String(grid.dataset.variantId) === String(variantId);

      grid.hidden = !isCurrentVariant;


      if (isCurrentVariant) {
        matchingGridFound = true;
      }

    });


    /*
      --------------------------------------------------------
      CUSTOM MNS GRID VISIBILITY
      --------------------------------------------------------
    */

    root.hidden = !matchingGridFound;

    root.dataset.gridVisible =
      matchingGridFound ? 'true' : 'false';


    /*
      --------------------------------------------------------
      CUSTOM PRICING OVERRIDE STATE
      --------------------------------------------------------

      IMPORTANT:

      This is based on whether custom pricing metafield data
      exists for the selected variant — NOT merely whether
      a valid table was rendered.
    */

    root.dataset.promoActive =
      customPricingFound ? 'true' : 'false';


    /*
      --------------------------------------------------------
      BOLD OVERRIDE
      --------------------------------------------------------
    */

    setBoldVisibility(
      root,
      customPricingFound
    );


    /*
      Keep global CSS state synchronized.
    */

    syncDocumentActiveClass();
  }


  function scheduleUpdate(root) {

    /*
      Hyper/BOLD can update variant information
      slightly after the option selection.

      Run several checks so our custom pricing state
      wins after those updates finish.
    */

    [0, 50, 150, 300, 600].forEach((delay) => {

      window.setTimeout(() => {
        updateGrid(root);
      }, delay);

    });
  }


  function initializeRoot(root) {

    if (root.dataset.promoInitialized === 'true') {
      return;
    }


    root.dataset.promoInitialized = 'true';

    const productInfo = getProductInfo(root);


    /*
      Standard input changes.
    */

    productInfo.addEventListener('change', () => {
      scheduleUpdate(root);
    });


    productInfo.addEventListener('input', () => {
      scheduleUpdate(root);
    });


    /*
      Common Shopify/theme variant events.
    */

    [
      'variant:change',
      'variant:changed',
      'product:variant-change',
      'product:variant-changed',
      'optionValueSelectionChange'
    ].forEach((eventName) => {

      document.addEventListener(eventName, () => {
        scheduleUpdate(root);
      });

    });


    /*
      Hyper / FoxTheme.
    */

    if (
      window.FoxTheme &&
      FoxTheme.pubsub &&
      FoxTheme.pubsub.PUB_SUB_EVENTS &&
      FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange
    ) {

      FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
        () => {
          scheduleUpdate(root);
        }
      );

    }


    /*
      Browser back / forward variant URL changes.
    */

    window.addEventListener('popstate', () => {
      scheduleUpdate(root);
    });


    /*
      Initial state.
    */

    scheduleUpdate(root);
  }


  function initializeAll() {

    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initializeRoot);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );

  } else {

    initializeAll();

  }


  /*
    Shopify Theme Editor support.
  */

  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );

})();